<div class="container-fluid mt-3" *ngIf="!loading && solicitud">
  <mat-accordion class="status-accordion">
    <mat-expansion-panel [expanded]="true">

      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon>insights</mat-icon>
          Flujo de la Solicitud N° {{solicitud?.id}}
        </mat-panel-title>
        <mat-panel-description>
          Estado actual:
          <span class="badget ml-2" [ngClass]="{
            'badget-info': solicitud.status === EStatus.PENDIENTE || solicitud.status === EStatus.PROGRAMADA,
            'badget-success': solicitud.status === EStatus.FINALIZADA || solicitud.status === EStatus.APROBADA,
            'badget-warning': solicitud.status === EStatus.EN_SERVICIO || isRequestPaused || solicitud.status === EStatus.REABIERTA,
            'badget-danger': isRequestRejected
          }">
            {{ currentClientLabel }}
          </span>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <div class="stepper-container mt-2 mb-3">

        <div *ngFor="let step of workflowSteps; let i = index" class="step-wrapper" [ngClass]="getStepClass(i)">

          <div class="step-connector-filled"></div>

          <div class="step-node" [matTooltip]="'Estado: ' + solicitud.status">

            <mat-icon *ngIf="i === currentActiveStepIndex && isRequestRejected">block</mat-icon>
            <mat-icon *ngIf="i === currentActiveStepIndex && isRequestPaused">pause_circle_filled</mat-icon>
            <mat-icon *ngIf="i === currentActiveStepIndex && solicitud.status === EStatus.REABIERTA">loop</mat-icon>

            <mat-icon
              *ngIf="!(i === currentActiveStepIndex && (isRequestRejected || isRequestPaused || solicitud.status === EStatus.REABIERTA))">
              {{step.icon}}
            </mat-icon>
          </div>

          <span class="step-label">
            {{step.label}}
            <span *ngIf="i === currentActiveStepIndex && isRequestRejected"
              class="d-block text-danger">(Rechazada)</span>
          </span>
        </div>

      </div>

    </mat-expansion-panel>
  </mat-accordion>
</div>
<mat-card class="cardWithShadow">
  <mat-card-content class="">
    <div class="container">
      @if (isPendiente) {
      <h2>Solicitud pendiente número: <strong>{{solicitud?.id}}</strong></h2>
      } @else if (isAprobada) {
      <h2>Solicitud aprobada número: <strong>{{solicitud?.id}}</strong></h2>
      } @else if (isRechazada) {
      <h2>Solicitud rechazada número: <strong>{{solicitud?.id}}</strong></h2>
      } @else if (isValidada) {
      <h2>Solicitud validada número: <strong>{{solicitud?.id}}</strong></h2>
      } @else {
      <h2>Modificar solicitud número: <strong>{{solicitud?.id}}</strong></h2>
      }
      @if (isAprobada && !isReadOnly) {
      <div class="change-date-banner mb-3"
        style="padding: 16px; background-color: #FAFAFA; border: 1px solid #E0E0E0; border-radius: 4px; display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center;">
          <mat-icon style="margin-right: 8px; color: #757575;">event</mat-icon>
          <span>Cambiar fecha de visita</span>
        </div>
        <div style="display: flex; align-items: center; gap: 16px;">
          <mat-form-field appearance="outline" style="width: 200px; margin: 0;">
            <mat-label>Nueva fecha de visita</mat-label>
            <input matInput [matDatepicker]="changeDatePicker" [(ngModel)]="nuevaFechaVisita"
              [ngModelOptions]="{standalone: true}">
            <mat-datepicker-toggle matIconSuffix [for]="changeDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #changeDatePicker></mat-datepicker>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="cambiarFechaVisita()" [disabled]="!nuevaFechaVisita">
            <mat-icon>save</mat-icon>
            Guardar
          </button>
        </div>
      </div>
      }
      <form [formGroup]="solicitudForm">
        <div class="section-title">Información general</div>
        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Cliente</mat-label>
            <input matInput formControlName="client.nombre"
              [disabled]="solicitud?.status === 'validada' || isRechazada">
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Local</mat-label>
            <input matInput formControlName="local.nombre_local"
              [disabled]="solicitud?.status === 'validada' || isRechazada">
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Dirección local</mat-label>
            <input matInput formControlName="local.direccion"
              [disabled]="solicitud?.status === 'validada' || isRechazada">
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Valor servicio {{ getTipoServicioNombre(solicitudForm.get('tipoServicioId')?.value) ? ' ' +
              getTipoServicioNombre(solicitudForm.get('tipoServicioId')?.value) : '' }}</mat-label>
            <input matInput formControlName="valorPorLocal" type="number"
              [disabled]="(!isPendiente && !isReabierta && solicitud?.status !== 'reabierta' && solicitud?.status !== 'finalizada') || isRechazada || isAprobada || isValidada">
            <span matSuffix>UF</span>
          </mat-form-field>
        </div>

        <div class="form-row"
          *ngIf="solicitud?.status === 'finalizada' || solicitud?.status === 'reabierta' || isReabierta || solicitud?.status === 'validada' || isValidada">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Registro de visita</mat-label>
            <input matInput formControlName="registroVisita" rows="4" placeholder="Ingrese los detalles de la visita"
              [disabled]="solicitud?.status === 'validada' || isValidada" />
          </mat-form-field>
        </div>

        <!-- CR-202608-0034 - Habilitar sección de imágenes de respaldo/papeleta para estado atendida_en_proceso -->
        @if (solicitud?.status === 'finalizada' || solicitud?.status === 'reabierta' || solicitud?.status ===
        'validada' || solicitud?.status === 'atendida_en_proceso' || isAtendidaEnProceso) {
        <div class="row m-b-16">
          <div class="radio-group-container col-md-4" *ngIf="solicitud?.status !== 'atendida_en_proceso' && !isAtendidaEnProceso">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Garantía</mat-label>
              <mat-select formControlName="garantia" required>
                <mat-option [value]="null">Seleccione una causa</mat-option>
                <mat-option value="si">Si</mat-option>
                <mat-option value="no">No</mat-option>
              </mat-select>
              <mat-error>Este campo es requerido</mat-error>
            </mat-form-field>
          </div>

          <div class="radio-group-container col-md-4" *ngIf="solicitud?.status !== 'atendida_en_proceso' && !isAtendidaEnProceso">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Turno</mat-label>
              <mat-select formControlName="turno" required>
                <mat-option [value]="null">Seleccione una causa</mat-option>
                <mat-option value="diurno">Diurno</mat-option>
                <mat-option value="nocturno">Nocturno</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="radio-group-container col-md-4" *ngIf="solicitud?.status !== 'atendida_en_proceso' && !isAtendidaEnProceso">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Estado solicitud</mat-label>
              <mat-select formControlName="estado_solicitud" required>
                <mat-option [value]="null">Seleccione una causa</mat-option>
                <mat-option value="resuelto">Resuelto</mat-option>
                <mat-option value="no_resuelto">No resuelto</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="radio-group-container col-md-4" *ngIf="solicitud?.status !== 'atendida_en_proceso' && !isAtendidaEnProceso">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Causa Raíz</mat-label>
              <mat-select formControlName="causaRaizId">
                <mat-option [value]="null">Sin Causa Raíz</mat-option>
                <mat-option *ngFor="let causa of causasRaiz" [value]="causa.id">
                  {{ causa.nombre }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="radio-group-container col-md-3" *ngIf="solicitud?.status !== 'atendida_en_proceso' && !isAtendidaEnProceso">
            <mat-form-field appearance="fill" class="full-width">
              <mat-label>Mes de Facturación</mat-label>
              <mat-select formControlName="facturacion_id" required>
                <mat-option [value]="null">Seleccione el periodo</mat-option>
                <mat-option *ngFor="let fact of periodosFacturacion" [value]="fact.id_facturacion || fact.id">
                  {{ fact.mes }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-md-12">
            <!-- CR-202608-0034 - Adaptar título del bloque según el estado de la visita -->
            <div class="section-title m-t-0">
              {{ (solicitud?.status === 'atendida_en_proceso' || isAtendidaEnProceso) ? 'Foto Registro de Visita / Respaldo Papeleta' : 'Imágenes de OT' }}
            </div>

            @if (otImages.length > 0) {
            <div class="d-flex flex-wrap gap-4 mb-4 justify-content-center">
              @for (img of otImages; track $index) {
              <div style="display: flex; flex-direction: column; align-items: center; gap: 8px;">
                <div class="image-box"
                  style="width: 180px; height: 180px; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                  <img loading="lazy" [src]="img" alt="Imagen de OT / Respaldo Visita" class="img-preview equipo-thumbnail"
                    style="width: 100%; height: 100%; object-fit: cover;" matTooltip="Hacer clic para ampliar"
                    (click)="openImageInLightbox(img, $event)" />
                </div>

                <div class="w-100 d-flex justify-content-center gap-3">
                  @if (!isValidada && !isRechazada && !isReadOnly) {
                  <button type="button" mat-icon-button color="warn" (click)="eliminarImagenOT($index)"
                    matTooltip="Eliminar imagen">
                    <mat-icon>delete</mat-icon>
                  </button>
                  }
                </div>
              </div>
              }
            </div>
            }

            @if (!isValidada && !isRechazada && !isReadOnly) {
            <div class="drop-area" (click)="fileInput.click()" (dragover)="onDragOver($event)" (drop)="onDrop($event)"
              style="border: 2px dashed #ccc; border-radius: 8px; padding: 20px; text-align: center; cursor: pointer; background-color: #f8f9fa; transition: all 0.3s ease; width: 100%; max-width: 400px; margin: 0 auto;">
              <mat-icon
                style="font-size: 48px; width: 48px; height: 48px; color: #666; margin-bottom: 10px;">collections</mat-icon>
              <!-- CR-202608-0034 - Texto descriptivo para la carga de respaldo de visita -->
              <p style="margin: 0; font-size: 16px; color: #333;">
                {{ (solicitud?.status === 'atendida_en_proceso' || isAtendidaEnProceso) ? 'Cargar foto respaldo de visita / papeleta' : 'Cargar imágenes de OT' }}
              </p>
              <p style="margin: 5px 0 0; font-size: 14px; color: #666;">Arrastra y suelta aquí o haz clic para seleccionar</p>
            </div>
            }

            <input #fileInput type="file" multiple (change)="onFileSelected($event)" accept="image/*"
              style="display: none;" [disabled]="isValidada || isRechazada || isUploadingOT || isReadOnly" />
          </div>
        </div>
        }

        <div class="form-row m-t-16">
          <mat-form-field appearance="fill" class="full-width"
            *ngIf="esGruman || solicitudForm.get('fechaVisita')?.value">
            <mat-label>Fecha de Visita</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="fechaVisita" />
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div *ngIf="!esGruman && !solicitudForm.get('fechaVisita')?.value"
            style="flex: 1; align-content: center; color: #64748b; font-size: 13px;">
            <i>Fecha de visita se asignará por Gruman una vez aprobado.</i>
          </div>

          <mat-form-field appearance="fill" class="full-width"
            *ngIf="esGruman || solicitudForm.get('tecnico_asignado_id')?.value">
            <mat-label>Técnico asignado</mat-label>
            <!-- Se añade evento selectionChange para autoguardado inmediato -->
            <mat-select formControlName="tecnico_asignado_id" (selectionChange)="onTecnicoAsignadoChange($event.value)">
              <mat-option [value]="null">Sin asignar</mat-option>
              <mat-option *ngFor="let tecnico of tecnicos" [value]="tecnico.id">
                <div style="display: flex; align-items: center; justify-content: space-between;"
                  [matTooltip]="'Especialidades: ' + getTecnicoEspecialidades(tecnico)">
                  <span>{{tecnico.name}} {{tecnico.lastName}}</span>
                  @if (tecnicoTieneEspecialidad(tecnico)) {
                  <span
                    style="color: #4CAF50; font-size: 18px; margin-left: 8px; font-weight: bold; display: flex; align-items: center;"
                    matTooltip="Técnico con la especialidad requerida">
                    ✓
                  </span>
                  }
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div *ngIf="!esGruman && !solicitudForm.get('tecnico_asignado_id')?.value"
            style="flex: 1; align-content: center; color: #64748b; font-size: 13px;">
            <i>Técnico será asignado por Gruman.</i>
          </div>
        </div>

        <div class="form-row">
          <mat-form-field appearance="fill" class="full-width"
            *ngIf="esGruman || solicitudForm.get('tecnico_asignado_id_2')?.value">
            <mat-label>Técnico asignado 2 (Opcional)</mat-label>
            <!--  Se añade evento selectionChange para autoguardado del técnico 2 -->
            <mat-select formControlName="tecnico_asignado_id_2" (selectionChange)="onTecnicoAsignado2Change($event.value)">
              <mat-option [value]="null">Sin asignar</mat-option>
              <mat-option *ngFor="let tecnico of getTecnicosDisponiblesParaSegundoSelect()" [value]="tecnico.id">
                <div style="display: flex; align-items: center; justify-content: space-between;"
                  [matTooltip]="'Especialidades: ' + getTecnicoEspecialidades(tecnico)">
                  <span>{{tecnico.name}} {{tecnico.lastName}}</span>
                  @if (tecnicoTieneEspecialidad(tecnico)) {
                  <span
                    style="color: #4CAF50; font-size: 18px; margin-left: 8px; font-weight: bold; display: flex; align-items: center;"
                    matTooltip="Técnico con la especialidad requerida">
                    ✓
                  </span>
                  }
                </div>
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div style="flex: 1;"></div>
        </div>

        @if (isPendiente) {
        <div
          style="margin-bottom: 16px; padding: 8px 12px; background-color: #f5f7fa; border-radius: 4px; font-size: 14px; color: #555; border-left: 3px solid #4CAF50;">
          <strong>Nota:</strong> Los técnicos marcados con <span style="color: #4CAF50; font-weight: bold;">✓</span>
          tienen la especialidad requerida para esta solicitud.
        </div>
        }

        <div class="section-title">Detalles de la solicitud</div>

        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Tipo de servicio</mat-label>
            @if (isPendiente && !isRechazada) {
            <mat-select formControlName="tipoServicioId">
              <mat-option *ngFor="let tipo of tiposServicio" [value]="tipo.id">
                {{tipo.nombre}}
              </mat-option>
            </mat-select>
            } @else {
            <input matInput [value]="getTipoServicioNombre(solicitud?.tipoServicioId)" disabled>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Tipo Solicitud</mat-label>
            @if (isPendiente && !isRechazada) {
            <mat-select formControlName="tipoSolicitudId">
              <mat-option *ngFor="let tipo of tiposSolicitud" [value]="tipo.id">
                <div>
                  <strong>{{ tipo.nombre | uppercase }}</strong><br>
                  <small style="font-size: 10px;">Día(s): {{ tipo.sla_dias }} / Hora(s): {{ tipo.sla_hora }}</small>
                </div>
              </mat-option>
            </mat-select>
            } @else {
            <input matInput [value]="getTipoSolicitudNombre(solicitud?.tipoSolicitudId)" disabled>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Sector de trabajo</mat-label>
            @if ((isPendiente || (isAprobada && esGruman) || isAtendidaEnProceso) && !isRechazada && !isReadOnly) {
            <mat-select formControlName="sectorTrabajoId">
              <mat-option *ngFor="let sector of sectoresTrabajos" [value]="sector.id">
                {{sector.nombre}}
              </mat-option>
            </mat-select>
            } @else {
            <input matInput [value]="getSectorTrabajoNombre(solicitud?.sectorTrabajoId)" disabled>
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Especialidad</mat-label>
            @if ((isPendiente || (isAprobada && esGruman) || isAtendidaEnProceso) && !isRechazada && !isReadOnly) {

            <mat-select formControlName="especialidad">
              <mat-option *ngFor="let esp of especialidades" [value]="esp.id">
                {{esp.nombre}}
              </mat-option>
            </mat-select>

            } @else {
            <input matInput [value]="getEspecialidadNombre(solicitud?.especialidad)" disabled>
            }
          </mat-form-field>
        </div>

        <div class="form-row">
          <mat-form-field appearance="fill">
            <mat-label>Ticket cliente</mat-label>
            <input matInput [value]="solicitud?.ticketGruman" disabled>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Status</mat-label>
            <input matInput [value]="solicitud?.status" disabled>
          </mat-form-field>
        </div>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Observaciones</mat-label>
          @if (isValidated() || isRechazada || isValidada || isAprobada) {
          <textarea matInput [value]="solicitud?.observaciones" rows="4" disabled></textarea>
          } @else {
          <textarea matInput formControlName="observaciones" rows="4"></textarea>
          }
        </mat-form-field>

        @if (solicitud?.imagenes?.length) {
        <div class="section-title">Imágenes de la Solicitud</div>
        <div class="images-container">
          <div class="image-grid">
            @for (imagen of solicitud.imagenes; track $index) {
            <div class="image-item">
              <img [src]="imagen" alt="Imagen de la solicitud" class="solicitud-image equipo-thumbnail"
                matTooltip="Hacer clic para ampliar" (click)="openImageInLightbox(imagen, $event)">

              <div class="image-actions">
                <button mat-icon-button color="accent" (click)="downloadPhotos([imagen])" matTooltip="Descargar imagen">
                  <mat-icon>download</mat-icon>
                </button>
              </div>
            </div>
            }
          </div>
        </div>
        }

        <div class="section-title" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">
          Fechas de Servicio
        </div>
        <div class="form-row" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">

          <mat-form-field appearance="fill">
            <mat-label>Fecha/Hora Inicio Servicio</mat-label>
            @if (isValidada || isRechazada || isAprobada) {
            <input matInput [value]="solicitud?.fecha_hora_inicio_servicio | date:'dd-MM-yyyy HH:mm'" disabled>
            } @else {
            <input matInput type="datetime-local" formControlName="fecha_hora_inicio_servicio">
            }
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Fecha/Hora Fin Servicio</mat-label>
            @if (isValidada || isRechazada || isAprobada) {
            <input matInput [value]="solicitud?.fecha_hora_fin_servicio | date:'dd-MM-yyyy HH:mm'" disabled>
            } @else {
            <input matInput type="datetime-local" formControlName="fecha_hora_fin_servicio">
            }
          </mat-form-field>

        </div>

        <div class="section-title" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">
          Detalles de registro
        </div>
        <div class="form-row" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">
          <div class="service-meta-row">
            <span *ngIf="solicitud?.is_offline === true" class="service-badge service-badge--offline">
              <mat-icon class="service-badge__icon">wifi_off</mat-icon>
              Registrado en <b>modo offline</b>
            </span>
            <span *ngIf="solicitud?.is_offline === false" class="service-badge service-badge--online">
              <mat-icon class="service-badge__icon">wifi</mat-icon>
              Registrado en <b>modo online</b>
            </span>
            <span *ngIf="solicitud?.version_app" class="service-badge service-badge--version">
              <mat-icon class="service-badge__icon">phone_android</mat-icon>
              Versión de la app: {{ solicitud.version_app }}
            </span>
          </div>
        </div>

        <div class="section-title" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">Ubicación</div>
        <div class="form-row" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">
          <mat-form-field appearance="fill">
            <mat-label>Latitud</mat-label>
            @if (isValidated() || isRechazada || isValidada) {
            <input matInput [value]="solicitud?.latitud_movil" disabled>
            } @else {
            <input matInput formControlName="latitud_movil" type="number" step="0.000001">
            }
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-label>Longitud</mat-label>
            @if (isValidated() || isRechazada || isValidada) {
            <input matInput [value]="solicitud?.longitud_movil" disabled>
            } @else {
            <input matInput formControlName="longitud_movil" type="number" step="0.000001">
            }
          </mat-form-field>
        </div>

        <div class="detail-section"
          *ngIf="(!isPendiente && !isAprobada && !isRechazada || isValidada) && solicitud?.latitud_movil && solicitud?.longitud_movil">
          <h3>Ubicación del Local</h3>
          <div class="map-container">
            <div class="map-frame">
              <div id="map" style="height: 400px; width: 100%; border: 1px solid #ccc;"></div>
            </div>
          </div>
        </div>

        <div class="section-title" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">Firma del Cliente
        </div>
        <div class="signature-container"
          *ngIf="(!isPendiente && !isAprobada && !isRechazada || isValidada) && solicitud?.firma_cliente">
          <div class="signature-box">
            <img [src]="solicitud.firma_cliente" alt="Firma del cliente" class="signature-image">
          </div>
        </div>

        <div class="section-title" *ngIf="(!isPendiente && !isAprobada && !isRechazada) || isValidada">Comentario
          General</div>
        <div class="form-row" *ngIf="(!isPendiente && !isAprobada && !isRechazada) || isValidada">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Ingrese comentario de cierre o validación</mat-label>
            <textarea matInput formControlName="comentario_general" name="comentario_general_auto" rows="4"
              placeholder="Observaciones generales del servicio..." (input)="onComentarioGeneralChange($event)">
            </textarea>
          </mat-form-field>
        </div>

        <div *ngIf="isDfontanaDisabled" class="alert alert-warning d-flex align-items-center m-b-16" style="background-color: #fff3cd; color: #856404; padding: 12px; border-radius: 8px;">
          <mat-icon style="margin-right: 8px;">link_off</mat-icon>
          <span>La integración con Dfontana se encuentra actualmente <strong>desactivada</strong> por el administrador.</span>
        </div>

        <div class="section-title mt-4"
          *ngIf="solicitud?.status === 'finalizada' || solicitud?.status === 'reabierta' && !isValidada">
          Tipo de movimiento de inventario (Descuento de Stock)
        </div>
        <div class="form-row"
          *ngIf="solicitud?.status === 'finalizada' || solicitud?.status === 'reabierta' && !isValidada">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Tipo de movimiento de inventario</mat-label>
            <mat-select formControlName="tipoMovimientoInventarioId">
              <mat-option>
                <input matInput type="text" placeholder="Buscar tipo de movimiento..."
                  [(ngModel)]="tipoMovimientoSearchTerm" [ngModelOptions]="{standalone: true}"
                  (input)="filterTiposMovimiento()" (click)="$event.stopPropagation()"
                  style="padding: 8px; width: 100%; border: 1px solid #ddd; border-radius: 4px; margin-bottom: 8px;" />
              </mat-option>
              <mat-option [value]="null">Ninguno</mat-option>
              <mat-option *ngFor="let tipo of filteredTiposMovimiento" [value]="tipo.code">
                {{ tipo.code }} - {{ tipo.name }}
              </mat-option>
            </mat-select>
            <mat-hint>Seleccione el tipo de servicio para el descuento de stock en Dfontana (opcional)</mat-hint>
          </mat-form-field>
        </div>

        <!-- CR-202607-0010 - Separación de información presupuestaria de la Solicitud -->
        <div class="section-title mt-4" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">
          Desglose y Presupuestos de la Solicitud
        </div>

        @if(checklistResponse?.is_climate){
        <div class="activos-fijos-container">

          <!-- Expandir todos los activos de clima simultáneamente sin cerrar el anterior -->
          <mat-accordion multi>
            <mat-expansion-panel *ngFor="let activoFijo of checklistResponse?.climate_data">
              <mat-expansion-panel-header style="height: auto;">
                <mat-panel-title>
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    @if (activoFijo.estadoOperativo==='funcionando') {
                    <small class="dot-green"></small>
                    } @else if (activoFijo.estadoOperativo==='sin_acceso') {
                    <small class="dot-yellow"></small>
                    } @else {
                    <small class="dot-red"></small>
                    }
                    <div style="font-size: 1rem; font-weight: normal;">
                      <!-- Resolución dinámica del nombre usando getActivoFijoDetails -->
                      <span style="font-weight: bold;">[{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.marca }}]</span>
                      {{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.codigo_activo }} - {{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.tipo_equipo }}
                    </div>

                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="activo-fijo-content p-5">
                @for (lista of activoFijo.checklist; track lista.id) {
                <h4 class="title-list-inspection">{{lista.categoria}}</h4>
                <section class="section-list-inspection">
                  @for (item of lista.items; track item.id) {
                  <h5 class="item-list-inspection">{{item.nombre}}</h5>
                  @for (subItem of item.subItems; track subItem.id; let i = $index) {
                  <div class="subitem-container">
                    <div style="display: flex; justify-content: flex-start; gap: 10px; align-items: center;">
                      <span class="tag-status-selector" [ngClass]="{
                              'tag-success': subItem.estado === 'aprobado',
                              'tag-danger': subItem.estado === 'rechazado',
                              'tag-warning': subItem.estado === 'no_aplica'
                            }"
                        [style.cursor]="(solicitud?.status === 'validada' || isRechazada || isValidada) ? 'default' : 'pointer'"
                        (click)="$event.preventDefault(); $event.stopPropagation(); (solicitud?.status === 'validada' || isRechazada || isValidada) ? null : openStatusMenu(subItem, activoFijo?.activo_fijo_id)">
                        {{ subItem.estado === 'no_aplica' ? 'No aplica' : (subItem.estado | titlecase) }}
                      </span>
                      <h6 class="subitem-title">{{subItem.nombre}}</h6>
                    </div>
                    <ng-container>
                      <small style="font-size: 12px; font-weight: bold;">Imágenes</small>
                      <div class="photos-container">
                        <div class="photo-grid">
                          <div class="photo-item" *ngFor="let foto of subItem.fotos; let i = index">
                            <div class="photo-container">
                              @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                              <!-- Pasar activoFijo.activo_fijo_id para acotar la eliminación de imágenes al activo correspondiente -->
                              <button mat-icon-button class="delete-btn-overlay"
                                (click)="eliminarImagenSubitem(subItem.id, i, activoFijo.activo_fijo_id)" matTooltip="Eliminar imagen">
                                <mat-icon>delete</mat-icon>
                              </button>
                              }
                              <img [src]="foto" [alt]="'Foto de ' + subItem.name"
                                class="inspection-photo equipo-thumbnail" matTooltip="Hacer clic para ampliar"
                                (click)="openImageInLightbox(foto, $event)">
                            </div>
                          </div>


                          @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                          <div class="photo-item add-photo-item">
                            <div class="add-photo-container"
                              (click)="triggerFileInput(subItem.id, activoFijo.activo_fijo_id, i)">
                              <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #666;">add</mat-icon>
                              <span style="font-size: 12px; color: #666; margin-top: 8px;">Agregar imagen</span>
                            </div>
                          </div>
                          }
                        </div>
                      </div>
                      <input #fileInputSubitem type="file"
                        (change)="onFileSelectedForSubitem($event, subItem.id, activoFijo.activo_fijo_id)" accept="image/*"
                        style="display: none;" [id]="'fileInput-' + subItem.id + '-' + activoFijo.activo_fijo_id + '-' + i"
                        [disabled]="solicitud?.status === 'validada' || isRechazada || isValidada" />
                    </ng-container>
                    <small style="color: #666; font-size: 11px;">SubItem ID: {{subItem.id}} - Activo ID:
                      {{activoFijo.activo_fijo_id}}</small>

                    <ng-container>
                      <div>
                        <strong>Comentario:</strong>
                        @if (solicitud?.status === 'validada' || isRechazada || isValidada) {
                        <span>{{ subItem.observaciones || 'N/A' }}</span>
                        } @else {
                        <mat-form-field appearance="outline" style="width: 100%; margin-top: 8px;">
                          <!-- Corrección referencia de 'activoNormal' a 'activoFijo.activo_fijo_id' en parametro y name -->
                          <textarea matInput [(ngModel)]="subItem.observaciones" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="actualizarObservacionesEnChecklist(subItem.id, $event, activoFijo.activo_fijo_id)" rows="2"
                            placeholder="Ingrese comentario"
                            name="obs_climate_{{activoFijo.activo_fijo_id}}_{{subItem.id}}">
                          </textarea>
                        </mat-form-field>
                        }
                      </div>
                    </ng-container>

                    <ng-container>
                      <div class="repuestos-table-container">
                        <div class="table-header">
                          <h4>Repuestos</h4>
                          <div class="d-flex flex-row items-center justify-content-between gap-2">
                            <button mat-button color="primary" class="small-button"
                              *ngIf="solicitud?.status !== 'validada' && !isRechazada && !isValidada"
                              (click)="agregarRepuesto(subItem.id, activoFijo.activo_fijo_id)" matTooltip="Agregar repuesto">
                              Agregar repuestos <mat-icon>add</mat-icon>
                            </button>
                            @if (showAddRepuestoForm[subItem.id]) {
                            <div class="d-flex flex-row gap-2">
                              <mat-form-field>
                                <mat-label>Seleccionar Repuesto</mat-label>
                                <mat-select [(ngModel)]="selectedRepuesto" [ngModelOptions]="{standalone: true}">
                                  @for (repuesto of repuestosList; track repuesto.id) {
                                  <mat-option [value]="repuesto">
                                    {{ repuesto.articulo }} - {{ repuesto.marca }} - ${{
                                    getPrecioRepuestoCliente(repuesto, 'venta').toLocaleString('es-CL') }}
                                  </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>

                              <mat-form-field>
                                <mat-label>Cantidad</mat-label>
                                <input matInput type="number" [(ngModel)]="newRepuestoCantidad"
                                  [ngModelOptions]="{standalone: true}" min="1">
                              </mat-form-field>

                              <div class="form-actions">
                                <button mat-button (click)="toggleAddRepuestoForm(subItem.id)">
                                  Cancelar
                                </button>
                                <button mat-raised-button color="primary" (click)="addRepuestoToItem(subItem.id)">
                                  Agregar
                                </button>
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                        <table class="repuestos-table">
                          <thead>
                            <tr>
                              <th>Artículo</th>
                              <th>Marca</th>
                              <th>Cantidad</th>
                              <th>Precio</th>
                              <th>Total</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (repuesto of subItem.repuestos; track repuesto.id) {
                            <tr>
                              <td>{{ repuesto.repuesto?.articulo || 'N/A' }}</td>
                              <td>{{ repuesto.repuesto?.marca || 'N/A' }}</td>
                              <td>{{ repuesto.cantidad || 'N/A' }}</td>
                              <td>${{ repuesto.precio_venta | number }}</td>
                              <td>${{ repuesto.precio_venta * repuesto.cantidad | number }}</td>
                              <td class="actions-cell">
                                @if (solicitud?.status !== 'validada' && !isValidada && !isRechazada) {
                                  <button mat-icon-button color="primary"
                                    (click)="editarRepuesto(subItem.id, repuesto, activoFijo.activo_fijo_id)" matTooltip="Editar">
                                    <mat-icon>edit</mat-icon>
                                  </button>
                                  <button mat-icon-button color="warn"
                                    (click)="eliminarRepuesto(subItem.id, repuesto, activoFijo.activo_fijo_id)"
                                    matTooltip="Eliminar">
                                    <mat-icon>delete</mat-icon>
                                  </button>
                                }
                              </td>
                            </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </ng-container>
                  </div>
                  }
                  }
                </section>
                }

                @if(checklistResponse?.is_climate){

                <div class="detalle-activo-fijo-section">
                  <h4 class="detail-section-title">Detalle activo fijo</h4>
                  <!-- Reemplazo global de variables estáticas por evaluación dinámica -->
                  <div class="detail-grid">
                    <div class="detail-item">
                      <span class="detail-label">Código:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.codigo_activo || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">Marca:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.marca || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">Tipo:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.tipo_equipo || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">Potencia:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.potencia_equipo || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">OnOff:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.on_off_inverter || '-' }}</span>
                    </div>
                    <div class="detail-item">
                      <span class="detail-label">Refrigerante:</span>
                      <span class="detail-value">{{ getActivoFijoDetails(activoFijo.activo_fijo_id)?.refrigerante || '-' }}</span>
                    </div>
                  </div>

                  @if (activoFijo.estadoOperativo === 'detenido') {
                  <div class="no-operatividad-section">
                    <h5 class="no-operatividad-title">
                      <mat-icon class="warning-icon">warning</mat-icon>
                      Activo No Operativo
                    </h5>

                    <div class="no-operatividad-content">
                      <ng-container>
                        <small style="font-size: 12px; font-weight: bold; color: #c62828;">Evidencia Fotográfica</small>
                        <div class="photos-container">
                          <div class="photo-grid">

                            @if (activoFijo.photo_not_operational) {
                            <div class="photo-item">
                              <div class="photo-container" style="border-color: #ef9a9a;">
                                @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                                <button mat-icon-button class="delete-btn-overlay"
                                  (click)="eliminarImagenActivo(activoFijo.activo_fijo_id)"
                                  matTooltip="Eliminar imagen">
                                  <mat-icon>delete</mat-icon>
                                </button>
                                }
                                <img [src]="activoFijo.photo_not_operational" alt="Evidencia no operativo"
                                  class="inspection-photo equipo-thumbnail" matTooltip="Hacer clic para ampliar"
                                  (click)="openImageInLightbox(activoFijo.photo_not_operational, $event)">
                              </div>
                            </div>
                            }

                            @if (!activoFijo.photo_not_operational && solicitud?.status !== 'validada' && !isRechazada
                            && !isValidada) {
                            <div class="photo-item add-photo-item"
                              style="border-color: #e57373; background-color: #ffebee;">
                              <div class="add-photo-container"
                                (click)="triggerFileInputActivo(activoFijo.activo_fijo_id)">
                                <mat-icon
                                  style="font-size: 48px; width: 48px; height: 48px; color: #ef5350;">add_a_photo</mat-icon>
                                <span style="font-size: 12px; color: #c62828; margin-top: 8px;">Subir Evidencia</span>
                              </div>
                            </div>
                            }
                          </div>
                        </div>

                        <input #fileInputActivo type="file"
                          (change)="onFileSelectedForActivo($event, activoFijo.activo_fijo_id)" accept="image/*"
                          style="display: none;" [id]="'fileInput-activo-' + activoFijo.activo_fijo_id"
                          [disabled]="solicitud?.status === 'validada' || isRechazada || isValidada" />
                      </ng-container>

                      <div class="observacion-item mt-3">
                        <span class="observacion-label" style="color: #c62828;">Motivo / Observación:</span>

                        @if (solicitud?.status === 'validada' || isRechazada || isValidada) {
                        <div class="observacion-value">{{activoFijo.observacionesEstado}}</div>
                        } @else {
                        <mat-form-field appearance="outline" style="width: 100%; margin-top: 8px;" color="warn">
                          <textarea matInput [(ngModel)]="activoFijo.observacionesEstado"
                            [ngModelOptions]="{standalone: true}" name="obs_estado_{{activoFijo.activo_fijo_id}}"
                            (ngModelChange)="actualizarObservacionActivo(activoFijo.activo_fijo_id, $event)" rows="3"
                            placeholder="Describa el motivo de la no operatividad..."
                            style="color: #b71c1c;"></textarea>
                        </mat-form-field>
                        }
                      </div>

                    </div>
                  </div>
                  }

                  @if (activoFijo.estadoOperativo === 'sin_acceso') {
                  <div class="sin-acceso-section"
                    style="margin-top: 20px; padding: 16px; background-color: #fff3e0; border-left: 4px solid #ff9800; border-radius: 4px;">
                    <h5
                      style="display: flex; align-items: center; color: #f57c00; margin: 0 0 16px 0; font-size: 16px;">
                      <mat-icon style="margin-right: 8px; color: #f57c00;">block</mat-icon>
                      Sin Acceso al Activo
                    </h5>

                    <div class="sin-acceso-content">
                      <div style="margin-bottom: 16px;">
                        <mat-form-field appearance="outline" style="width: 100%;">
                          <mat-label>Estado del activo</mat-label>
                          @if (solicitud?.status === 'validada' || isRechazada || isValidada) {
                          <input matInput
                            [value]="activoFijo.operativo_sin_acceso === true ? 'Operativo' : activoFijo.operativo_sin_acceso === false ? 'No Operativo' : 'No especificado'"
                            disabled>
                          } @else {
                          <mat-select [(ngModel)]="activoFijo.operativo_sin_acceso"
                            [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="actualizarOperativoSinAcceso(activoFijo.activo_fijo_id, $event)">
                            <mat-option [value]="true">Operativo</mat-option>
                            <mat-option [value]="false">No Operativo</mat-option>
                          </mat-select>
                          }
                          <mat-hint>Indique si el activo está operativo o no operativo a pesar de no tener
                            acceso</mat-hint>
                        </mat-form-field>
                      </div>

                      <ng-container>
                        <small style="font-size: 12px; font-weight: bold; color: #f57c00;">Evidencia Fotográfica</small>
                        <div class="photos-container">
                          <div class="photo-grid">

                            @if (activoFijo.photo_not_operational) {
                            <div class="photo-item">
                              <div class="photo-container" style="border-color: #ffb74d;">
                                @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                                <button mat-icon-button style="z-index: 9900;" color="warn"
                                  (click)="eliminarImagenActivo(activoFijo.activo_fijo_id)"
                                  matTooltip="Eliminar imagen">
                                  <mat-icon>delete</mat-icon>
                                </button>
                                }
                                <img [src]="activoFijo.photo_not_operational" alt="Evidencia sin acceso"
                                  class="inspection-photo equipo-thumbnail" matTooltip="Hacer clic para ampliar"
                                  (click)="openImageInLightbox(activoFijo.photo_not_operational, $event)">
                              </div>
                            </div>
                            }

                            @if (!activoFijo.photo_not_operational && solicitud?.status !== 'validada' && !isRechazada
                            && !isValidada) {
                            <div class="photo-item add-photo-item"
                              style="border-color: #ffb74d; background-color: #fff3e0;">
                              <div class="add-photo-container"
                                (click)="triggerFileInputActivo(activoFijo.activo_fijo_id)">
                                <mat-icon
                                  style="font-size: 48px; width: 48px; height: 48px; color: #f57c00;">add_a_photo</mat-icon>
                                <span style="font-size: 12px; color: #f57c00; margin-top: 8px;">Subir Evidencia</span>
                              </div>
                            </div>
                            }
                          </div>
                        </div>

                        <input #fileInputActivo type="file"
                          (change)="onFileSelectedForActivo($event, activoFijo.activo_fijo_id)" accept="image/*"
                          style="display: none;" [id]="'fileInput-activo-' + activoFijo.activo_fijo_id"
                          [disabled]="solicitud?.status === 'validada' || isRechazada || isValidada" />
                      </ng-container>

                      <div class="observacion-item mt-3">
                        <span class="observacion-label" style="color: #f57c00;">Motivo / Observación:</span>

                        @if (solicitud?.status === 'validada' || isRechazada || isValidada) {
                        <div class="observacion-value">{{activoFijo.observacionesEstado}}</div>
                        } @else {
                        <mat-form-field appearance="outline" style="width: 100%;">
                          <textarea matInput [(ngModel)]="activoFijo.observacionesEstado"
                            [ngModelOptions]="{standalone: true}"
                            name="obs_estado_sin_acceso_{{activoFijo.activo_fijo_id}}"
                            (ngModelChange)="actualizarObservacionActivo(activoFijo.activo_fijo_id, $event)" rows="3"
                            placeholder="Describa el motivo por el cual no se pudo acceder al activo..."
                            style="color: #f57c00;"></textarea>
                        </mat-form-field>
                        }
                      </div>

                    </div>
                  </div>
                  }
                </div>

                }

              </div>

            </mat-expansion-panel>
          </mat-accordion>

        </div>
        } @else {
        <div class="activos-fijos-container">
          <!-- Expandir todos los activos normales simultáneamente sin cerrar el anterior -->
          <mat-accordion multi>
            @for (activoNormal of checklistResponse?.data_normal; track activoNormal.activo_fijo_id) {
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header style="height: auto;">
                  <mat-panel-title>
                    <div style="display: flex; justify-content: flex-start; align-items: center; gap: 8px;">
                      @if (activoNormal.estadoOperativo === 'funcionando') {
                        <small class="dot-green"></small>
                      } @else if (activoNormal.estadoOperativo === 'sin_acceso') {
                        <small class="dot-yellow"></small>
                      } @else {
                        <small class="dot-red"></small>
                      }
                      <span style="font-size: 1rem; font-weight: 600;">
                        {{ getActivoFijoDetails(activoNormal.activo_fijo_id)?.codigo_activo || ('Activo ' + activoNormal.activo_fijo_id) }}
                      </span>
                      @if (getActivoFijoDetails(activoNormal.activo_fijo_id)?.tipo_equipo) {
                        <span style="font-size: 0.8rem; color: #666; margin-left: 4px;">
                          — {{ getActivoFijoDetails(activoNormal.activo_fijo_id)?.tipo_equipo }}
                        </span>
                      }
                      <span class="activo-estado-badge" [ngClass]="{
                        'badge-operativo': activoNormal.estadoOperativo === 'funcionando',
                        'badge-no-operativo': activoNormal.estadoOperativo === 'detenido',
                        'badge-sin-acceso': activoNormal.estadoOperativo === 'sin_acceso'
                      }">
                        {{ activoNormal.estadoOperativo === 'funcionando' ? 'Operativo' :
                           activoNormal.estadoOperativo === 'sin_acceso' ? 'Sin acceso' : 'No operativo' }}
                      </span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="activo-fijo-content p-5">
                  @if (!activoNormal.checklist || activoNormal.checklist.length === 0) {
                    <!-- Activo no operativo / sin acceso -->
                    <div class="subitem-container">
                      @if (activoNormal.comment) {
                        <p><strong>Comentario:</strong> {{ activoNormal.comment }}</p>
                      }
                      @if (activoNormal.photo_not_operational) {
                        <div class="photos-container">
                          <div class="photo-grid">
                            <div class="photo-item">
                              <div class="photo-container">
                                <img [src]="activoNormal.photo_not_operational"
                                  alt="Foto de evidencia"
                                  class="inspection-photo equipo-thumbnail"
                                  matTooltip="Hacer clic para ampliar"
                                  (click)="openImageInLightbox(activoNormal.photo_not_operational, $event)">
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  } @else {
                  @for (lista of activoNormal.checklist; track lista.id) {
                  <h4 class="title-list-inspection">{{lista.categoria}}</h4>
                  <section class="section-list-inspection">
                    @for (item of lista.items; track item.id) {
                    <h5 class="item-list-inspection">{{item.nombre}}</h5>
                    <!-- Agregar 'let i = $index' para estructurar identificadores únicos en el bucle -->
                    @for (subItem of item.subItems; track subItem.id; let i = $index) {
                    <div class="subitem-container">
                      <div style="display: flex; justify-content: flex-start; gap: 10px; align-items: center;">
                        <!-- Vincular selector de estado al activoNormal.activo_fijo_id -->
                        <span class="tag-status-selector" [ngClass]="{
                                'tag-success': subItem.estado === 'aprobado',
                                'tag-danger': subItem.estado === 'rechazado',
                                'tag-warning': subItem.estado === 'no_aplica'
                              }"
                              [style.cursor]="(solicitud?.status === 'validada' || isRechazada || isValidada) ? 'default' : 'pointer'"
                              (click)="$event.preventDefault(); $event.stopPropagation(); (solicitud?.status === 'validada' || isRechazada || isValidada) ? null : openStatusMenu(subItem, activoNormal.activo_fijo_id)">
                          {{ subItem.estado === 'no_aplica' ? 'No aplica' : (subItem.estado | titlecase) }}
                        </span>
                        <h6 class="subitem-title">{{subItem.nombre}}</h6>
                      </div>
                      <ng-container>
                        <small style="font-size: 12px; font-weight: bold;">Imágenes</small>
                        <div class="photos-container">
                          <div class="photo-grid">
                            <div class="photo-item" *ngFor="let foto of subItem.fotos; let fotoIdx = index">
                              <div class="photo-container">
                                @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                                <!-- Pasar activoNormal.activo_fijo_id para acotar la eliminación de la foto al activo correspondiente -->
                                <button mat-icon-button class="delete-btn-overlay"
                                  (click)="eliminarImagenSubitem(subItem.id, fotoIdx, activoNormal.activo_fijo_id)" matTooltip="Eliminar imagen">
                                  <mat-icon>delete</mat-icon>
                                </button>
                                }
                                <img [src]="foto" [alt]="'Foto de ' + subItem.name" class="inspection-photo equipo-thumbnail"
                                  matTooltip="Hacer clic para ampliar" (click)="openImageInLightbox(foto, $event)">
                              </div>
                            </div>

                            @if (solicitud?.status !== 'validada' && !isRechazada && !isValidada) {
                            <div class="photo-item add-photo-item">
                              <!-- Pasar activoNormal.activo_fijo_id al disparar la selección de imagen -->
                              <div class="add-photo-container" (click)="triggerFileInput(subItem.id, activoNormal.activo_fijo_id, i)">
                                <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #666;">add</mat-icon>
                                <span style="font-size: 12px; color: #666; margin-top: -10px;">Agregar imagen</span>
                              </div>
                            </div>
                            }
                          </div>
                        </div>
                        <!-- Concatenar activoNormal.activo_fijo_id al id del input para asegurar unicidad DOM -->
                        <input #fileInputSubitem type="file" (change)="onFileSelectedForSubitem($event, subItem.id, activoNormal.activo_fijo_id)"
                          accept="image/*" style="display: none;" [id]="'fileInput-' + subItem.id + '-' + activoNormal.activo_fijo_id + '-' + i"
                          [disabled]="solicitud?.status === 'validada' || isRechazada || isValidada" />
                      </ng-container>

                      <ng-container>
                        <div>
                          <strong>Comentario:</strong>
                          @if (solicitud?.status === 'validada' || isRechazada || isValidada) {
                          <span>{{ subItem.observaciones || 'N/A' }}</span>
                          } @else {
                          <mat-form-field appearance="outline" style="width: 100%; margin-top: 8px;">
                            <textarea matInput [(ngModel)]="subItem.observaciones" [ngModelOptions]="{standalone: true}"
                              (ngModelChange)="actualizarObservacionesEnChecklist(subItem.id, $event, activoNormal.activo_fijo_id)" rows="2"
                              placeholder="Ingrese comentario"
                              name="obs_normal_{{activoNormal.activo_fijo_id}}_{{subItem.id}}">
                            </textarea>
                          </mat-form-field>
                          }
                        </div>
                      </ng-container>

                      <ng-container>
                        <div class="repuestos-table-container">
                          <div class="table-header">
                            <h4>Repuestos</h4>
                            <div class="d-flex flex-row items-center justify-content-between gap-2">
                              <!-- FIX: Pasar activoNormal.activo_fijo_id para evitar asociar el repuesto a todos los activos de data_normal -->
                              <button mat-button color="primary" class="small-button"
                                *ngIf="solicitud?.status !== 'validada' && !isRechazada && !isValidada"
                                (click)="agregarRepuesto(subItem.id, activoNormal.activo_fijo_id)" matTooltip="Agregar repuesto">
                                Agregar repuestos <mat-icon>add</mat-icon>
                              </button>
                              @if (showAddRepuestoForm[subItem.id]) {
                              <div class="d-flex flex-row gap-2">
                                <mat-form-field>
                                  <mat-label>Seleccionar Repuesto</mat-label>
                                  <mat-select [(ngModel)]="selectedRepuesto" [ngModelOptions]="{standalone: true}">
                                    @for (repuesto of repuestosList; track repuesto.id) {
                                    <mat-option [value]="repuesto">
                                      {{ repuesto.articulo }} - {{ repuesto.marca }} - ${{ getPrecioRepuestoCliente(repuesto,
                                      'venta').toLocaleString('es-CL') }}
                                    </mat-option>
                                    }
                                  </mat-select>
                                </mat-form-field>

                                <mat-form-field>
                                  <mat-label>Cantidad</mat-label>
                                  <input matInput type="number" [(ngModel)]="newRepuestoCantidad"
                                    [ngModelOptions]="{standalone: true}" min="1">
                                </mat-form-field>

                                <div class="form-actions">
                                  <button mat-button (click)="toggleAddRepuestoForm(subItem.id)">
                                    Cancelar
                                  </button>
                                  <button mat-raised-button color="primary" (click)="addRepuestoToItem(subItem.id)">
                                    Agregar
                                  </button>
                                </div>
                              </div>
                              }
                            </div>
                          </div>
                          <table class="repuestos-table">
                            <thead>
                              <tr>
                                <th>Artículo</th>
                                <th>Marca</th>
                                <th>Cantidad</th>
                                <th>Precio</th>
                                <th>Total</th>
                                <th>Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (repuesto of subItem.repuestos; track repuesto.id) {
                              <tr>
                                <td>{{ repuesto.repuesto?.articulo || 'N/A' }}</td>
                                <td>{{ repuesto.repuesto?.marca || 'N/A' }}</td>
                                <td>{{ repuesto.cantidad || 'N/A' }}</td>
                                <td>${{ repuesto.precio_venta | number }}</td>
                                <td>${{ repuesto.precio_venta * repuesto.cantidad | number }}</td>                                
                                <td class="actions-cell">
                                  @if (solicitud?.status !== 'validada' && !isValidada && !isRechazada) {
                                    <!-- 🛠️ FIX: Pasar activoNormal.activo_fijo_id para acotar edicion y eliminacion al activo especifico -->
                                    <button mat-icon-button color="primary" (click)="editarRepuesto(subItem.id, repuesto, activoNormal.activo_fijo_id)"
                                      matTooltip="Editar">
                                      <mat-icon>edit</mat-icon>
                                    </button>
                                    <button mat-icon-button color="warn" (click)="eliminarRepuesto(subItem.id, repuesto, activoNormal.activo_fijo_id)"
                                      matTooltip="Eliminar">
                                      <mat-icon>delete</mat-icon>
                                    </button>
                                  }
                                </td>
                              </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </ng-container>
                    </div>
                    }
                  }
                   </section>
                  }
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
        }






        <div class="checklist-clima-section" *ngIf="solicitud?.checklistsClima?.length > 0">
          <h3 class="section-title">Checklist de Clima</h3>

          @for (checklist of solicitud.checklistsClima; track checklist.id) {
          <mat-card class="checklist-card mb-4">
            <mat-card-header>
              <mat-card-title>
                Activo Fijo: {{ getActivoFijoInfo(checklist.activoFijoId) }}
              </mat-card-title>
              <mat-card-subtitle>
                Fecha: {{ checklist.createdAt | date:'dd/MM/yyyy HH:mm' }}
              </mat-card-subtitle>
            </mat-card-header>

            <mat-card-content>
              <div class="mediciones-section">
                <h4>Mediciones de Temperatura</h4>
                <table class="table-checklist">
                  <tr>
                    <th>Medición</th>
                    <th>Valor</th>
                    <th>Observación</th>
                  </tr>
                  <tr>
                    <td>Set Point</td>
                    <td>{{ checklist.medicion_SetPoint }}°C</td>
                    <td>{{ checklist.medicion_SetPoint_observacion }}</td>
                  </tr>
                  <tr>
                    <td>Temp. Inyección Frío</td>
                    <td>{{ checklist.medicion_TempInjeccionFrio }}°C</td>
                    <td>{{ checklist.medicion_TempInjeccionFrio_observacion }}</td>
                  </tr>
                  <tr>
                    <td>Temp. Inyección Calor</td>
                    <td>{{ checklist.medicion_TempInjeccionCalor }}°C</td>
                    <td>{{ checklist.medicion_TempInjeccionCalor_observacion }}</td>
                  </tr>
                  <tr>
                    <td>Temp. Ambiente</td>
                    <td>{{ checklist.medicion_TempAmbiente }}°C</td>
                    <td>{{ checklist.medicion_TempAmbiente_observacion }}</td>
                  </tr>
                  <tr>
                    <td>Temp. Retorno</td>
                    <td>{{ checklist.medicion_TempRetorno }}°C</td>
                    <td>{{ checklist.medicion_TempRetorno_observacion }}</td>
                  </tr>
                  <tr>
                    <td>Temp. Exterior</td>
                    <td>{{ checklist.medicion_TempExterior }}°C</td>
                    <td>{{ checklist.medicion_TempExterior_observacion }}</td>
                  </tr>
                </table>
              </div>

              <div class="consumos-section mt-4">
                <h4>Consumos y Tensiones</h4>
                <div class="grid-container">
                  <div class="grid-item">
                    <h5>Consumo Compresor</h5>
                    <table class="table-checklist">
                      <tr>
                        <td>R:</td>
                        <td>{{ checklist.consumoCompresor_R }}A</td>
                      </tr>
                      <tr>
                        <td>S:</td>
                        <td>{{ checklist.consumoCompresor_S }}A</td>
                      </tr>
                      <tr>
                        <td>T:</td>
                        <td>{{ checklist.consumoCompresor_T }}A</td>
                      </tr>
                      <tr>
                        <td>N:</td>
                        <td>{{ checklist.consumoCompresor_N }}A</td>
                      </tr>
                    </table>
                  </div>

                  <div class="grid-item">
                    <h5>Tensiones</h5>
                    <table class="table-checklist">
                      <tr>
                        <td>R-S:</td>
                        <td>{{ checklist.tension_R_S }}V</td>
                      </tr>
                      <tr>
                        <td>S-T:</td>
                        <td>{{ checklist.tension_S_T }}V</td>
                      </tr>
                      <tr>
                        <td>T-R:</td>
                        <td>{{ checklist.tension_T_R }}V</td>
                      </tr>
                      <tr>
                        <td>T-N:</td>
                        <td>{{ checklist.tension_T_N }}V</td>
                      </tr>
                    </table>
                  </div>

                  <div class="grid-item">
                    <h5>Consumo Total</h5>
                    <table class="table-checklist">
                      <tr>
                        <td>R:</td>
                        <td>{{ checklist.consumo_total_R }}A</td>
                      </tr>
                      <tr>
                        <td>S:</td>
                        <td>{{ checklist.consumo_total_S }}A</td>
                      </tr>
                      <tr>
                        <td>T:</td>
                        <td>{{ checklist.consumo_total_T }}A</td>
                      </tr>
                      <tr>
                        <td>N:</td>
                        <td>{{ checklist.consumo_total_N }}A</td>
                      </tr>
                    </table>
                  </div>

                  <div class="grid-item">
                    <h5>Presiones</h5>
                    <table class="table-checklist">
                      <tr>
                        <td>Alta:</td>
                        <td>{{ checklist.presiones_alta }}PSI</td>
                      </tr>
                      <tr>
                        <td>Baja:</td>
                        <td>{{ checklist.presiones_baja }}PSI</td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
          }
        </div>

        <div class="final-total-section" *ngIf="!isPendiente && !isAprobada && !isRechazada || isValidada">

          <div class="final-total-amount">
            <strong>Total Final:</strong>
            <span>${{checklistResponse?.total_final | number:'1.0-0' }}</span>

          </div>
        </div>

        @if (isPendiente && !isReadOnly) {
        <div
          style="display: flex; align-items: center; gap: 8px; padding: 12px; background-color: #e3f2fd; border-radius: 4px; margin-bottom: 20px;">
          <mat-icon style="color: #1976d2;">info</mat-icon>
          <span style="color: #1565c0; font-size: 14px;">
            {{ esGruman
            ? 'Si asignas Técnico y Fecha ahora, la solicitud pasará directamente a Programada.'
            : 'Revisa los datos de la solicitud y presiona Aprobar. Gruman se encargará de asignar técnico y fecha.'
            }}
          </span>
        </div>
        }

        <div class="actions">
          <button mat-button
            [style.color]="solicitud?.status === 'validada' || isAprobada || isRechazada ? '#1976d2' : ''"
            (click)="onCancel()">
            {{ solicitud?.status !== 'validada' && !isAprobada && !isRechazada ? 'Cancelar' : 'Volver' }}
          </button>

          @if (isPendiente) {
          @if (!isReadOnly) {
          <button mat-raised-button color="primary" (click)="aprobarSolicitud()" style="margin-right: 10px;"
            [disabled]="loading">
            <mat-icon>check_circle</mat-icon>
            {{ esGruman && solicitudForm.get('tecnico_asignado_id')?.value && solicitudForm.get('fechaVisita')?.value ?
            'Aprobar y Programar' : 'Aprobar' }}
          </button>

          <button mat-raised-button color="warn" (click)="rechazarSolicitud()" [disabled]="loading">
            <mat-icon>cancel</mat-icon> Rechazar
          </button>
          }
          } @else if (isAprobada) {
          <div class="approved-banner mb-3"
            style="color: #2196F3; padding: 16px; background-color: #E3F2FD; border-radius: 4px; display: flex; align-items: center; min-height: 56px;">
            <mat-icon
              style="margin-right: 8px; height: 24px; width: 24px; font-size: 24px; line-height: 24px;">schedule</mat-icon>
            <span style="line-height: 24px;">Esta solicitud está aprobada y a la espera de la visita del técnico</span>
          </div>

          @if (esGruman && !isReadOnly) {
          <button mat-raised-button color="primary" class="btn-schedule-new" (click)="programarVisitaTecnica()"
            [disabled]="loading || !solicitudForm.get('tecnico_asignado_id')?.value || !solicitudForm.get('fechaVisita')?.value">
            <mat-icon>event_available</mat-icon> Programar Visita Técnica
          </button>
          }

          } @else if (isRechazada) {
          <div class="rejected-message"
            style="color: #F44336; padding: 15px; background-color: #FFEBEE; border-radius: 4px; display: flex; align-items: center; justify-content: center; width: 100%; flex-direction: column; margin-bottom: 15px;">
            <div style="display: flex; align-items: center; width: 100%; justify-content: center; margin-bottom: 10px;">
              <mat-icon
                style="vertical-align: middle; margin-right: 8px; font-size: 28px; height: 28px; width: 28px;">cancel</mat-icon>
              <span style="font-weight: bold; font-size: 18px;">Esta solicitud fue rechazada</span>
            </div>

            @if (solicitud?.rechazada_por_id && usuarioRechazo) {
            <div style="width: 100%; text-align: center; margin-top: 8px; font-size: 16px;">
              <strong>Rechazada por:</strong> {{ usuarioRechazo.name }} {{ usuarioRechazo.lastName }}
            </div>
            }

            @if (solicitud?.fecha_rechazo) {
            <div style="width: 100%; text-align: center; margin-top: 8px; font-size: 16px;">
              <strong>Fecha:</strong> {{ solicitud.fecha_rechazo | date:'HH:mm dd-MM-yyyy' }}
            </div>
            }

            @if (solicitud?.observacion_rechazo) {
            <div
              style="width: 100%; text-align: center; margin-top: 8px; padding: 10px; background-color: rgba(244, 67, 54, 0.1); border-radius: 4px; font-size: 16px;">
              <strong>Motivo:</strong> {{ solicitud.observacion_rechazo }}
            </div>
            }
          </div>
          } @else if (solicitud?.status !== 'validada' && !isValidada) {
          @if (!isReadOnly) {
          @if (isEnServicio) {
          <button mat-raised-button style="background-color: #4CAF50; color: white; margin-right: 10px;" (click)="finalizarServicioManual()">
            <mat-icon>task_alt</mat-icon> Finalizar Trabajo con Éxito
          </button>
          <button mat-raised-button style="background-color: #f57c00; color: white;" (click)="dejarAtendidaEnProcesoManual()">
            <mat-icon>pause_circle_outline</mat-icon> Dejar Atendida En Proceso
          </button>
          } @else if (isAtendidaEnProceso) {
          <button mat-raised-button color="primary" (click)="reprogramarVisita()">
            <mat-icon>event_available</mat-icon> Reprogramar Visita
          </button>
          } @else {
          <button mat-raised-button style="background-color: #4CAF50; color: white;" (click)="onValidate()">
            Validar solicitud
          </button>
          }
          }
          } @else {
          <div class="validation-message"
            style="color: #4CAF50; padding: 10px; background-color: #E8F5E9; border-radius: 4px; display: flex; align-items: center; justify-content: center; width: 100%;">
            <mat-icon style="vertical-align: middle; margin-right: 8px;">check_circle</mat-icon>
            Esta solicitud fue validada el {{ solicitud?.fecha_hora_validacion | date:'HH:mm dd-MM-yyyy' }}
          </div>
          }
        </div>
      </form>
    </div>

  </mat-card-content>
</mat-card>

<div class="autosave-indicator" [class.visible]="isAutoSaving">
  <div class="beacon"></div>
  <span class="text">Guardando cambios...</span>
</div>

<ng-template #statusDialog>
  <div class="status-dialog-container">
    <div class="status-dialog-header">
      <mat-icon>edit_note</mat-icon>
      <h2>Cambiar estado de inspección</h2>
    </div>

    <mat-dialog-content class="status-dialog-content">
      <p class="status-dialog-hint">Seleccione el nuevo estado para esta actividad:</p>

      <mat-radio-group [(ngModel)]="tempNuevoEstado" class="status-card-group">
        <div class="status-option-wrapper approved" [class.active]="tempNuevoEstado === 'aprobado'">
          <mat-radio-button value="aprobado">
            <span class="option-label">Aprobado</span>
          </mat-radio-button>
        </div>

        <div class="status-option-wrapper rejected" [class.active]="tempNuevoEstado === 'rechazado'">
          <mat-radio-button value="rechazado">
            <span class="option-label">Rechazado</span>
          </mat-radio-button>
        </div>

        <div class="status-option-wrapper na" [class.active]="tempNuevoEstado === 'no_aplica'">
          <mat-radio-button value="no_aplica">
            <span class="option-label">No Aplica</span>
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </mat-dialog-content>

    <mat-dialog-actions class="status-dialog-actions">
      <button mat-button mat-dialog-close class="btn-cancel">
        Cancelar
      </button>
      <button mat-raised-button class="btn-confirm" [mat-dialog-close]="tempNuevoEstado">
        Confirmar Cambio
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>